export enum DocumentSource {
  USER_UPLOAD = 'USER_UPLOAD',
  OCR_OUTPUT = 'OCR_OUTPUT',
  TEMPLATE_GENERATED = 'TEMPLATE_GENERATED',
  TEST_UPLOAD = 'TEST_UPLOAD',
  ENCRYPTED = 'ENCRYPTED',
  DECRYPTED = 'DECRYPTED',
  EMAIL_ATTACHMENT = 'EMAIL_ATTACHMENT',
  AI_GENERATED = 'AI_GENERATED',
}

export const DocumentSourceLabels: Record<string, string> = {
  [DocumentSource.USER_UPLOAD]: 'User Upload',
  [DocumentSource.OCR_OUTPUT]: 'OCR Output',
  [DocumentSource.TEMPLATE_GENERATED]: 'Template Generated',
  [DocumentSource.TEST_UPLOAD]: 'Test Upload',
  [DocumentSource.ENCRYPTED]: 'Encrypted',
  [DocumentSource.DECRYPTED]: 'Decrypted',
  [DocumentSource.EMAIL_ATTACHMENT]: 'Email Attachment',
  [DocumentSource.AI_GENERATED]: 'AI Generated',
}

export interface InstanceDocument {
  fileId: string
  fileName: string
  fileSize: number
  mimeType: string
  source: DocumentSource
  uploadedAt: string
  uploadedBy: string
  downloadPath: string
}
